export default __webpack_public_path__ + "static/media/lds-logo_id.aea7a61ad0c49fd1.svg";